import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-diseases',
  templateUrl: './diseases.component.html',
  styleUrls: ['./diseases.component.scss'],
})
export class DiseasesComponent {}
